// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-tool-body {
    display: grid;
    grid-template-columns: repeat(3,1fr);
    gap: 3vw;
    
}

.box {
    border: 5px solid blue;
    border-radius: 20px;
    padding: 20px;
}
.box-image{
    width: 100%;
    display: flex;
    justify-content: center;
}

.box-image img {
    width: 100%;
    border-radius: 20px;
    height: 300px;
}
.box-details {
    margin-top: 10px;
}
.box-logo{
    width: 200px;
    height: 80px;
}
.box-logo img{
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.box-tags {
    margin-bottom: 10px;
}

.box-tag {
    background-color: #3689a1;
    padding: 5px 10px;
    margin-right: 5px;
    border-radius: 5px;
    display: inline-block;
    
}
.box-tag-2 {
    background-color: #c5f7cd;
    padding: 5px 10px;
    margin-right: 5px;
    border-radius: 5px;
    display: inline-block;
}

.view-details-btn {
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 20px 20px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
    width: 100%;
    font-weight: bold;
    letter-spacing: 2px;
}
.p-tag-tool{
    padding: 5px;
    border: 1px dotted black;
    width: max-content;
}
@media (max-width:1280px) {
    .container-tool-body{
        grid-template-columns: repeat(3,1fr);
    }
}
@media (max-width:1080px) {
    .container-tool-body{
        grid-template-columns: repeat(2,1fr);
    }
}
@media (max-width:840px) {
    .container-tool-body{
        grid-template-columns: repeat(2,1fr);
    }
}
@media (max-width:600px) {
    .container-tool-body{
        grid-template-columns: repeat(1,1fr);
        width:95%;
        margin-left: auto;
        margin-right: auto;

    }
    .box-image img {
        height: 200px;
    }
    .box-logo{
        width: 150px;
        height: 60px;
    }
    .box {
        border: 5px solid blue;
        border-radius: 20px;
        padding: 10px;
        margin-bottom: 10px;
        /* padding-left: 0; */
        /* padding-right: 0; */
        width:100%;
        margin-right: auto;
        margin-left: auto;
    }
    .view-details-btn {

        width: 80%;
   
    }
    .box-logo img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .box-image img {
        width: 100%;
        border-radius: 20px;
        height: 300px;
    }
    .box-tag-2 {
        background-color: #c5f7cd;
        padding: 0px 0px;
        margin-right: 0px;
        border-radius: 5px;
        display: inline-block;
    }


}`, "",{"version":3,"sources":["webpack://./src/Toolpage/MainBody.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oCAAoC;IACpC,QAAQ;;AAEZ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;;AAEzB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;AACtB;AACA;IACI;QACI,oCAAoC;IACxC;AACJ;AACA;IACI;QACI,oCAAoC;IACxC;AACJ;AACA;IACI;QACI,oCAAoC;IACxC;AACJ;AACA;IACI;QACI,oCAAoC;QACpC,SAAS;QACT,iBAAiB;QACjB,kBAAkB;;IAEtB;IACA;QACI,aAAa;IACjB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,qBAAqB;QACrB,sBAAsB;QACtB,UAAU;QACV,kBAAkB;QAClB,iBAAiB;IACrB;IACA;;QAEI,UAAU;;IAEd;IACA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,aAAa;IACjB;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,qBAAqB;IACzB;;;AAGJ","sourcesContent":[".container-tool-body {\n    display: grid;\n    grid-template-columns: repeat(3,1fr);\n    gap: 3vw;\n    \n}\n\n.box {\n    border: 5px solid blue;\n    border-radius: 20px;\n    padding: 20px;\n}\n.box-image{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.box-image img {\n    width: 100%;\n    border-radius: 20px;\n    height: 300px;\n}\n.box-details {\n    margin-top: 10px;\n}\n.box-logo{\n    width: 200px;\n    height: 80px;\n}\n.box-logo img{\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.box-tags {\n    margin-bottom: 10px;\n}\n\n.box-tag {\n    background-color: #3689a1;\n    padding: 5px 10px;\n    margin-right: 5px;\n    border-radius: 5px;\n    display: inline-block;\n    \n}\n.box-tag-2 {\n    background-color: #c5f7cd;\n    padding: 5px 10px;\n    margin-right: 5px;\n    border-radius: 5px;\n    display: inline-block;\n}\n\n.view-details-btn {\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    padding: 20px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n    width: 100%;\n    font-weight: bold;\n    letter-spacing: 2px;\n}\n.p-tag-tool{\n    padding: 5px;\n    border: 1px dotted black;\n    width: max-content;\n}\n@media (max-width:1280px) {\n    .container-tool-body{\n        grid-template-columns: repeat(3,1fr);\n    }\n}\n@media (max-width:1080px) {\n    .container-tool-body{\n        grid-template-columns: repeat(2,1fr);\n    }\n}\n@media (max-width:840px) {\n    .container-tool-body{\n        grid-template-columns: repeat(2,1fr);\n    }\n}\n@media (max-width:600px) {\n    .container-tool-body{\n        grid-template-columns: repeat(1,1fr);\n        width:95%;\n        margin-left: auto;\n        margin-right: auto;\n\n    }\n    .box-image img {\n        height: 200px;\n    }\n    .box-logo{\n        width: 150px;\n        height: 60px;\n    }\n    .box {\n        border: 5px solid blue;\n        border-radius: 20px;\n        padding: 10px;\n        margin-bottom: 10px;\n        /* padding-left: 0; */\n        /* padding-right: 0; */\n        width:100%;\n        margin-right: auto;\n        margin-left: auto;\n    }\n    .view-details-btn {\n\n        width: 80%;\n   \n    }\n    .box-logo img{\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n    }\n    .box-image img {\n        width: 100%;\n        border-radius: 20px;\n        height: 300px;\n    }\n    .box-tag-2 {\n        background-color: #c5f7cd;\n        padding: 0px 0px;\n        margin-right: 0px;\n        border-radius: 5px;\n        display: inline-block;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
